var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "payment-link-order" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              model: _vm.form,
              "label-width": "250px",
              "label-position": "left",
            },
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("payment_links.time_line"))),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.create_time") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(_vm._s(_vm.form.create_time || "-")),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.complete_time") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(_vm._s(_vm.form.complete_time || "-")),
                ]),
              ]
            ),
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("payment_links.payment_breakdown"))),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.order_amount") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("toDivideWithDot")(_vm.form.order_amount))
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.transaction_fee") } },
              [
                _vm.form.fee_split
                  ? _c("span", { staticClass: "content-text" }, [
                      _vm._v(
                        _vm._s(_vm._f("toDivideWithDot")(_vm.form.fee_split))
                      ),
                    ])
                  : _c("span", { staticClass: "content-text" }, [_vm._v("-")]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.payment_amount") } },
              [
                _vm.form.payment_amount
                  ? _c("span", { staticClass: "content-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(_vm.form.payment_amount)
                        )
                      ),
                    ])
                  : _c("span", { staticClass: "content-text" }, [_vm._v("-")]),
              ]
            ),
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("payment_links.payment_description"))),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.checkout_order_id") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(_vm._s(_vm.form.checkout_id || "-")),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.merchant_order_id") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(_vm._s(_vm.form.merchant_order_id || "-")),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.payment_description") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(_vm._s(_vm.form.remark || "-")),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_name") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("strAesDecryptAndAsterisk")(_vm.form.customer_name)
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_email") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("strAesDecryptAndAsterisk")(_vm.form.email))
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("payment_links.customer_mobile") } },
              [
                _c("span", { staticClass: "content-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("strAesDecryptAndAsterisk")(_vm.form.mobile))
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("payment_links.transaction_fee_charge_mode"),
                },
              },
              [
                _vm.form.fee_split_type
                  ? _c("span", { staticClass: "content-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.form.fee_split_type ===
                            _vm.FEE_SPLIT_TYPE.merchant
                            ? _vm.$t(
                                "payment_links.transaction_fee_charge_mode1"
                              )
                            : _vm.$t(
                                "payment_links.transaction_fee_charge_mode2"
                              )
                        )
                      ),
                    ])
                  : _c("span", { staticClass: "content-text" }, [_vm._v("-")]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }